module.exports = __webpack_public_path__ + "img/icon_bg_mobile.4989ca2f.png";